import { thewest, setAssetDomain } from '@news-mono/component-library'
import { initClient } from '@news-mono/component-library'

setAssetDomain()
// We need this to get the dependencies loaded in the correct order
require('../app/app')

const { render, routeCacheRef } = initClient({
    version: { buildNumber: '', sha: '' },
    requireApplication: () => require('../app/app').App,
    theme: thewest,
})

if (module.hot) {
    module.hot.accept('../app/app', () => {
        if (routeCacheRef) {
            routeCacheRef.clear()
        }

        setTimeout(render)
    })
}
